/**
 * Clientes POS: buscar, crear y seleccionar.
 */

function escapeHtml(s) {
	const div = document.createElement('div');
	div.textContent = s;
	return div.innerHTML;
}

function formatoLineaCliente(cliente) {
	const nombre = cliente.nombre || 'Sin nombre';
	const doc = cliente.documento ? `Doc: ${cliente.documento}` : '';
	let email = cliente.email_mostrar || cliente.email || '';
	if (email && email.indexOf('@pos.local') !== -1) email = '';
	const segundos = [doc, email].filter(Boolean).join(' · ');
	return (
		`<div class="cliente-resultado-item">` +
		`<div class="cliente-resultado-nombre">${escapeHtml(nombre)}</div>` +
		(segundos ? `<div class="cliente-resultado-detalle">${escapeHtml(segundos)}</div>` : '') +
		`</div>`
	);
}

function renderResultadosClientes(lista, $) {
	const resultados = $('#resultados-busqueda');
	if (!lista.length) {
		resultados.hide();
		return;
	}
	let html = '';
	lista.forEach((cliente) => {
		const obj = {
			id: cliente.id,
			nombre: cliente.nombre || '',
			documento: cliente.documento || '',
			email: cliente.email || '',
			telefono: cliente.telefono || '',
			direccion: cliente.direccion || '',
		};
		const safe = JSON.stringify(obj).replace(/"/g, '&quot;');
		html += `<div class="cliente-resultado-row" onclick="seleccionarClienteExistente(${safe})">${formatoLineaCliente(cliente)}</div>`;
	});
	resultados.html(html).show();
}

export function attachCustomersGlobals(win, $) {
	win.mostrarClienteSeleccionado = function mostrarClienteSeleccionado() {
		const cliente = win.clienteSeleccionado;
		if (!cliente) return;
		$('#cliente-nombre').text(cliente.nombre);
		$('#cliente-documento').text(cliente.documento || 'Sin documento');
		$('#cliente-email').text(cliente.email || 'Sin email');
		$('#cliente-seleccionado').show();
		$('#cliente-badge').text(cliente.nombre.substring(0, 10)).show();
		$('#cliente-nombre-compacto').text(cliente.nombre);
		$('#cliente-seleccionado-compacto').show();
	};

	win.seleccionarClienteExistente = function seleccionarClienteExistente(cliente) {
		win.clienteSeleccionado = cliente;
		win.mostrarClienteSeleccionado();
		win.cerrarModal('modal-cliente');
		win.mostrarNotificacion(`Cliente seleccionado: ${cliente.nombre}`, 'success');
	};

	win.finalizarGuardadoCliente = function finalizarGuardadoCliente(nuevoCliente) {
		const clientes = JSON.parse(win.localStorage.getItem('clientes_pos') || '[]');
		clientes.push(nuevoCliente);
		win.localStorage.setItem('clientes_pos', JSON.stringify(clientes));
		win.clienteSeleccionado = nuevoCliente;
		win.mostrarClienteSeleccionado();
		win.cerrarModal('modal-cliente');
		win.mostrarNotificacion(`Cliente creado: ${nuevoCliente.nombre}`, 'success');
		$('.btn-agregar').prop('disabled', false).text('Crear Cliente');
	};

	win.guardarNuevoCliente = function guardarNuevoCliente() {
		const nombre = $('#nuevo-cliente-nombre').val().trim();
		const documento = $('#nuevo-cliente-documento').val().trim();
		const email = $('#nuevo-cliente-email').val().trim();
		const telefono = $('#nuevo-cliente-telefono').val().trim();
		const direccion = $('#nuevo-cliente-direccion').val().trim();

		if (!nombre) {
			win.mostrarNotificacion('El nombre es obligatorio', 'error');
			return;
		}

		const nuevoCliente = {
			id: null,
			nombre,
			documento,
			email,
			telefono,
			direccion,
			fechaCreacion: new Date().toLocaleString(),
		};

		$('.btn-agregar').prop('disabled', true).text('Guardando...');

		win.POSKN.api.saveCustomer(nuevoCliente, 20000)
			.done((response) => {
				if (response.success && response.data && response.data.customer_id) {
					nuevoCliente.id = response.data.customer_id;
					nuevoCliente.wp_customer_id = response.data.customer_id;
				} else {
					nuevoCliente.id = Date.now();
					if (response.success === false) {
						console.error('Error al guardar cliente en WordPress:', response.data);
					}
				}
				win.finalizarGuardadoCliente(nuevoCliente);
			})
			.fail((xhr, status, error) => {
				console.error('Error al guardar cliente:', error || status);
				nuevoCliente.id = Date.now();
				win.finalizarGuardadoCliente(nuevoCliente);
			});
	};

	win.cargarClientesGuardados = function cargarClientesGuardados() {
		const clientes = JSON.parse(win.localStorage.getItem('clientes_pos') || '[]');

		$('#buscar-cliente-modal').off('input.posknClientes').on('input.posknClientes', function () {
			const termino = $(this).val().trim();
			const terminoLower = termino.toLowerCase();
			const resultados = $('#resultados-busqueda');

			if (termino.length < 2) {
				resultados.hide();
				return;
			}

			const clientesFiltrados = clientes.filter(
				(cliente) =>
					(cliente.nombre && cliente.nombre.toLowerCase().includes(terminoLower)) ||
					(cliente.documento && String(cliente.documento).toLowerCase().includes(terminoLower)) ||
					(cliente.email && cliente.email.toLowerCase().includes(terminoLower))
			);

			win.POSKN.api
				.searchCustomers(termino)
				.done((res) => {
					const lista = [];
					const idsWp = {};
					if (res && res.success && res.data && res.data.length) {
						res.data.forEach((c) => {
							idsWp[c.id] = true;
							lista.push({
								id: c.id,
								nombre: c.nombre || '',
								documento: c.documento || '',
								email: c.email || '',
								email_mostrar: c.email_mostrar || c.email || '',
								telefono: c.telefono || '',
								direccion: c.direccion || '',
							});
						});
					}
					clientesFiltrados.forEach((c) => {
						if (!idsWp[c.id]) lista.push(c);
					});
					renderResultadosClientes(lista, $);
				})
				.fail(() => {
					renderResultadosClientes(clientesFiltrados, $);
				});
		});
	};

	win.abrirModalCliente = function abrirModalCliente() {
		const modalContent = `
                <div class="modal-overlay" id="modal-cliente" style="display: flex;">
                    <div class="modal-content" style="max-width: 500px;">
                        <div class="modal-header">
                            <div class="modal-title">👤 Crear/Buscar Cliente</div>
                            <button class="btn-cerrar" onclick="cerrarModal('modal-cliente')">&times;</button>
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Buscar Cliente Existente:</label>
                            <input type="text" class="form-input" id="buscar-cliente-modal" placeholder="Escribir nombre, documento o email...">
                            <div id="resultados-busqueda" class="resultados-cliente-list" style="max-height: 200px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 8px; margin-top: 8px; display: none; background: #fafafa;"></div>
                        </div>
                        
                        <div style="text-align: center; margin: 20px 0; color: #666;">- O -</div>
                        
                        <h4>Crear Nuevo Cliente</h4>
                        <div class="form-group">
                            <label class="form-label">Nombre Completo:*</label>
                            <input type="text" class="form-input" id="nuevo-cliente-nombre" placeholder="Nombre del cliente">
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Documento (CI/RIF):</label>
                            <input type="text" class="form-input" id="nuevo-cliente-documento" placeholder="V-12345678 o J-123456789">
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Email:</label>
                            <input type="email" class="form-input" id="nuevo-cliente-email" placeholder="cliente@email.com">
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Teléfono:</label>
                            <input type="tel" class="form-input" id="nuevo-cliente-telefono" placeholder="0412-1234567">
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Dirección:</label>
                            <textarea class="form-input" id="nuevo-cliente-direccion" rows="2" placeholder="Dirección del cliente"></textarea>
                        </div>
                        
                        <div style="display: flex; gap: 12px; margin-top: 20px;">
                            <button class="form-input" onclick="cerrarModal('modal-cliente')" style="background: #6b7280; color: white; border: none; cursor: pointer;">Cancelar</button>
                            <button class="btn-agregar" onclick="guardarNuevoCliente()">Crear Cliente</button>
                        </div>
                    </div>
                </div>
            `;

		$('#modal-cliente').remove();
		$('body').append(modalContent);
		win.cargarClientesGuardados();
	};

	win.limpiarCliente = function limpiarCliente() {
		win.resetClienteSeleccion(false);
	};

	win.resetClienteSeleccion = function resetClienteSeleccion(silent) {
		win.clienteSeleccionado = null;
		$('#cliente-seleccionado').hide();
		$('#cliente-badge').hide();
		$('#cliente-seleccionado-compacto').hide();
		$('#cliente-buscar').val('');
		if (!silent) {
			win.mostrarNotificacion('Cliente removido', 'success');
		}
	};
}
